// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610221022/js/" + chunkId + "." + {"44":"0b40f702","225":"08a66364","481":"e2a9d584","486":"3e4a5889","770":"3f4b7e85"}[chunkId] + ".0.1403486348192936.chunk.js";
};